import { render } from "./SearchBlock.vue?vue&type=template&id=e037d408&scoped=true"
import script from "./SearchBlock.vue?vue&type=script&lang=js"
export * from "./SearchBlock.vue?vue&type=script&lang=js"

import "./SearchBlock.vue?vue&type=style&index=0&id=e037d408&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e037d408"]])

export default __exports__